import { FinancialDocumentBase } from "@common/types/financialDocument";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { getFinancialDocumentFile } from "@lib/financialDocument";

export function useDownloadFinancialDocumentFile(
    financialDocument: Pick<FinancialDocumentBase, "id" | "fileName"> | null,
) {
    return useFileDownload(async () => {
        if (!financialDocument) {
            return;
        }

        const response = await getFinancialDocumentFile(financialDocument.id);

        saveBlobResponse(response, financialDocument.fileName);
    });
}
